import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Lock, Globe, BadgeCheck, Mail, HelpCircle } from 'lucide-react';

export default function Footer() {
  const navigate = useNavigate();
  
  return (
    <footer className="bg-slate-900 text-white py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Column 1 - Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/logo-cropped.png" alt="GlobalVyapar" className="h-10 w-auto" />
            </div>
            <p className="text-sm text-slate-400 mb-3">
              AI-powered B2B trade platform for Indian exporters.
            </p>
            <p className="text-xs text-slate-500 mt-1">Founded 2026, Mumbai, India</p>
          </div>
          
          {/* Column 2 - Platform */}
          <div>
            <h4 className="font-semibold mb-4">Platform</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <button onClick={() => navigate('/marketplace')} className="hover:text-white transition-colors text-left">
                  Marketplace
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/pricing')} className="hover:text-white transition-colors text-left">
                  Pricing
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/auth')} className="hover:text-white transition-colors text-left">
                  Login / Register
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/support')} className="hover:text-white transition-colors text-left">
                  Help & Support
                </button>
              </li>
            </ul>
          </div>
          
          {/* Column 3 - Security */}
          <div>
            <h4 className="font-semibold mb-4">Security</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li className="flex items-center gap-2">
                <Lock className="h-3 w-3" />
                256-bit SSL Encrypted
              </li>
              <li className="flex items-center gap-2">
                <Globe className="h-3 w-3" />
                India Data Centers
              </li>
              <li className="flex items-center gap-2">
                <BadgeCheck className="h-3 w-3" />
                GSTIN Verified Sellers
              </li>
              <li className="text-xs text-slate-500 mt-3">
                Compliant with IT Act 2000 & DPDP Act 2023
              </li>
            </ul>
          </div>
          
          {/* Column 4 - Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <a href="mailto:support@globalvyapar.co.in" className="hover:text-white transition-colors">
                  support@globalvyapar.co.in
                </a>
              </li>
              <li className="text-slate-500 mt-2">Mumbai, India</li>
              <li className="text-xs text-slate-500 mt-2">
                We reply within 4 hours on business days (Mon–Sat, 10am–7pm IST)
              </li>
            </ul>
            <Button 
              variant="outline" 
              size="sm" 
              className="mt-4 border-slate-600 text-slate-300 hover:bg-slate-800"
              onClick={() => navigate('/support')}
            >
              <HelpCircle className="h-4 w-4 mr-2" />
              Help & Support
            </Button>
          </div>
        </div>
        
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-slate-400 text-sm">
            © 2026 GlobalVyapar. All rights reserved.
          </p>
          <div className="flex items-center gap-4 mt-4 md:mt-0 text-sm text-slate-400">
            <button 
              onClick={() => navigate('/privacy-policy')} 
              className="hover:text-white transition-colors"
            >
              Privacy Policy
            </button>
            <button 
              onClick={() => navigate('/terms-of-service')} 
              className="hover:text-white transition-colors"
            >
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
